module.exports = __webpack_public_path__ + "img/icon-facebook.1ecf4ccd.svg";